import React, { useEffect, useState } from 'react';
import { Button, Card, Checkbox, Form, Input, Space, Switch } from 'antd';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/ImagePicker"
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import InputNumber from 'components/input-number';
import { formatCurrency } from "utils/number"
const service = new StoreSettingService();

const CollaboratorSetting = () => {
    const [form] = useForm();
    const { showLoading, showNotify } = useApp();
    const [oldSetting, setOldSetting] = useState({})
    const min_quantityValue = Form.useWatch('min_quantity', form);
    const min_amountValue = Form.useWatch('min_amount', form);
    useEffect(() => {
        loadData();
    }, []);



    const loadData = async () => {
        var setting = await service.getCollaboratorSetting();
        form.setFieldsValue(setting);
        setOldSetting(setting);
    }

    const onFinish = async values => {
        // console.log('Success:', values);
        showLoading(true);
        await service.saveCollaboratorSetting(values)
        await loadData();
        showLoading(false);
        showNotify("Đã cập nhật")
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };
    return (

        <Card>
            <Form
                form={form}
                name="basic"
                layout='vertical'
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >


                <Form.Item
                    label="Cho phép cộng tác viên"
                    name="collaborator"
                    rules={[{
                        required: true,

                    },

                    ]}
                    tooltip="Cho phép cộng tác viên tạo đơn hàng và hưởng hoa hồng"
                    valuePropName='checked'
                >
                  <Switch></Switch>
                </Form.Item>

                <Form.Item
                    label="Hoa hồng"
                    name="commission"
                    rules={[{
                        required: true,

                    },

                    ]}
                    tooltip="Tỉ lệ hoahồng"
                >
                    <InputNumber  />
                </Form.Item>


                

                <Form.Item label={null}>
                    <Button type="primary" htmlType="submit">
                        Cập nhật
                    </Button>
                </Form.Item>
            </Form>

        </Card>
    )
}
export default CollaboratorSetting;